/* ==========================================================================
   Vildblad 2.1 – smidiga detaljer från genomgången av andra butiker.
   Galleri med miniatyrer och helskärmszoom, beräknad leverans, dela, tillbaka till listan,
   senast visade, levande antal i filtret, senaste sökningar, innehållsförteckning i guider,
   till toppen, bakåtknappen (bfcache) och tvåstegsformuläret Ångra köp.
   Bygger på theme.js och vb2.js. Ingen extern kod. localStorage används bara för
   besökarens egna bekvämligheter och allt fungerar utan det.
   ========================================================================== */
(() => {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const V = window.Vildblad || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const behavior = reduceMotion ? 'auto' : 'smooth';
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  const store = {
    get(key, fallback) { try { const v = JSON.parse(window.localStorage.getItem(key)); return v == null ? fallback : v; } catch (e) { return fallback; } },
    set(key, value) { try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* privat läge */ } },
    remove(key) { try { window.localStorage.removeItem(key); } catch (e) { /* privat läge */ } },
    list(key) { const v = this.get(key, []); return Array.isArray(v) ? v.filter((x) => typeof x === 'string' && x) : []; }
  };

  const formatMoney = (cents) => {
    const n = Number(cents || 0) / 100;
    const fmt = V.moneyFormat || '{{amount}} kr';
    const delim = (num, dec, thou, sep) => {
      const [i, f] = num.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (dec ? sep + f : '');
    };
    return fmt.replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return delim(n, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(n, 0, '.', ',');
        case 'amount_with_space_separator': return delim(n, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return delim(n, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return delim(n, 2, "'", '.');
        default: return delim(n, 2, ',', '.');
      }
    });
  };

  /* ==========================================================================
     Produktsida: miniatyrer under galleriet (mobil)
     ========================================================================== */
  function initThumbs(section) {
    const thumbs = $('[data-gallery-thumbs]', section);
    const gallery = $('[data-gallery-list]', section);
    if (!thumbs || !gallery) return;
    const list = $('.gallery-thumbs__list', thumbs);
    const btns = $$('[data-thumb-index]', thumbs);
    let current = 0;

    const setActive = (i) => {
      btns.forEach((b, j) => {
        const on = j === i;
        b.classList.toggle('is-active', on);
        if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      const li = btns[i] && btns[i].parentElement;
      if (li && list.scrollWidth > list.clientWidth) {
        const left = li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2;
        list.scrollTo({ left: Math.max(0, left), behavior });
      }
    };

    let raf = 0;
    gallery.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        const center = gallery.scrollLeft + gallery.clientWidth / 2;
        let idx = 0;
        Array.from(gallery.children).forEach((item) => {
          if (item.offsetLeft - gallery.offsetLeft <= center) idx = parseInt(item.dataset.index, 10) || 0;
        });
        if (idx !== current) { current = idx; setActive(idx); }
      });
    }, { passive: true });

    btns.forEach((b) => b.addEventListener('click', () => {
      const i = parseInt(b.dataset.thumbIndex, 10) || 0;
      const item = $(`[data-index="${i}"]`, gallery);
      if (!item) return;
      const pad = parseFloat(getComputedStyle(gallery).paddingLeft || 0);
      gallery.scrollTo({ left: item.offsetLeft - gallery.offsetLeft - pad, behavior });
      current = i;
      setActive(i);
    }));
  }

  /* ==========================================================================
     Produktsida: helskärmsgalleri med zoom
     ========================================================================== */
  function initZoom(section) {
    const dialog = $('[data-zoom-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const track = $('[data-zoom-track]', dialog);
    const slides = $$('[data-zoom-slide]', dialog);
    const currentEl = $('[data-zoom-current]', dialog);
    const hint = $('[data-zoom-hint]', dialog);
    if (hint && coarse && hint.dataset.touch) hint.textContent = hint.dataset.touch;
    let opener = null;
    let index = 0;

    const zoomed = () => $('[data-zoom-frame].is-zoomed', dialog);
    const unzoom = () => {
      const f = zoomed();
      if (f) { f.classList.remove('is-zoomed'); f.scrollTo(0, 0); }
      dialog.classList.remove('is-zoomed');
    };
    const goTo = (i, smooth = true) => {
      index = Math.max(0, Math.min(slides.length - 1, i));
      unzoom();
      track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth ? behavior : 'auto' });
      if (currentEl) currentEl.textContent = String(index + 1);
    };
    const open = (mediaId, trigger) => {
      opener = trigger || document.activeElement;
      const i = Math.max(0, slides.findIndex((s) => s.dataset.mediaId === String(mediaId)));
      document.documentElement.classList.add('is-zoom-open');
      dialog.showModal();
      goTo(i, false);
    };

    section.addEventListener('click', (e) => {
      const z = e.target.closest('[data-zoom]');
      if (!z) return;
      e.preventDefault();
      open(z.closest('[data-media-id]')?.dataset.mediaId, z);
    });

    dialog.addEventListener('close', () => {
      unzoom();
      document.documentElement.classList.remove('is-zoom-open');
      if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
    });
    $('[data-zoom-close]', dialog)?.addEventListener('click', () => dialog.close());
    $('[data-zoom-prev]', dialog)?.addEventListener('click', () => goTo(index - 1));
    $('[data-zoom-next]', dialog)?.addEventListener('click', () => goTo(index + 1));
    dialog.addEventListener('keydown', (e) => {
      const isZoomed = dialog.classList.contains('is-zoomed');
      if ((e.key === '+' || e.key === '=') && !isZoomed) {
        e.preventDefault();
        const frame = $('[data-zoom-frame]', slides[index]);
        const r = frame.getBoundingClientRect();
        toggleZoom(frame, r.left + r.width / 2, r.top + r.height / 2);
        return;
      }
      if ((e.key === '-' || e.key === '0') && isZoomed) { e.preventDefault(); unzoom(); return; }
      if (isZoomed) return; // piltangenterna flyttar runt i den inzoomade bilden
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
    });

    track.addEventListener('scroll', debounce(() => {
      if (dialog.classList.contains('is-zoomed')) return;
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i !== index && slides[i]) { index = i; if (currentEl) currentEl.textContent = String(i + 1); }
    }, 60), { passive: true });

    // Zooma: klick med mus, dubbeltryck med finger. Punkten man pekar på hamnar i mitten.
    const toggleZoom = (frame, clientX, clientY) => {
      const img = $('img', frame);
      if (!img) return;
      if (frame.classList.contains('is-zoomed')) { unzoom(); return; }
      const r = img.getBoundingClientRect();
      const px = Math.min(1, Math.max(0, (clientX - r.left) / (r.width || 1)));
      const py = Math.min(1, Math.max(0, (clientY - r.top) / (r.height || 1)));
      frame.classList.add('is-zoomed');
      dialog.classList.add('is-zoomed');
      frame.setAttribute('tabindex', '-1');
      frame.focus({ preventScroll: true });
      frame.scrollLeft = px * img.offsetWidth - frame.clientWidth / 2;
      frame.scrollTop = py * img.offsetHeight - frame.clientHeight / 2;
    };
    let lastTap = { t: 0, x: 0, y: 0 };
    // Med mus: dra för att flytta runt i en inzoomad bild
    let drag = null;
    dialog.addEventListener('pointerdown', (e) => {
      const frame = e.target.closest('[data-zoom-frame].is-zoomed');
      if (!frame || e.pointerType !== 'mouse') return;
      drag = { frame, x: e.clientX, y: e.clientY, left: frame.scrollLeft, top: frame.scrollTop, moved: false };
      e.preventDefault();
    });
    dialog.addEventListener('pointermove', (e) => {
      if (!drag) return;
      const dx = e.clientX - drag.x;
      const dy = e.clientY - drag.y;
      if (Math.abs(dx) + Math.abs(dy) > 4) drag.moved = true;
      drag.frame.scrollLeft = drag.left - dx;
      drag.frame.scrollTop = drag.top - dy;
    });
    dialog.addEventListener('pointerup', (e) => {
      const wasDrag = drag && drag.moved;
      drag = null;
      const frame = e.target.closest('[data-zoom-frame]');
      if (!frame || !e.target.closest('img')) return;
      if (e.pointerType === 'mouse') { if (!wasDrag) toggleZoom(frame, e.clientX, e.clientY); return; }
      const now = Date.now();
      if (now - lastTap.t < 320 && Math.abs(e.clientX - lastTap.x) < 30 && Math.abs(e.clientY - lastTap.y) < 30) {
        toggleZoom(frame, e.clientX, e.clientY);
        lastTap = { t: 0, x: 0, y: 0 };
      } else {
        lastTap = { t: now, x: e.clientX, y: e.clientY };
      }
    });
  }

  /* ==========================================================================
     Beräknad leverans (bara när butiken slagit på den under Temainställningar → Leverans)
     ========================================================================== */
  const Delivery = (() => {
    const tz = 'Europe/Stockholm';
    const nowParts = () => {
      const p = Object.fromEntries(new Intl.DateTimeFormat('sv-SE', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).map((x) => [x.type, x.value]));
      return { y: +p.year, m: +p.month, d: +p.day, h: (+p.hour) % 24 };
    };
    const key = (d) => d.toISOString().slice(0, 10);
    const plusDays = (d, n) => new Date(d.getTime() + n * 86400000);
    const fmtShort = new Intl.DateTimeFormat('sv-SE', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
    const fmtLong = new Intl.DateTimeFormat('sv-SE', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });

    function compute(el) {
      const closed = new Set((el.dataset.closed || '').split(/[\s,;]+/).filter((s) => /^\d{4}-\d{2}-\d{2}$/.test(s)));
      const open = (d) => d.getUTCDay() !== 0 && d.getUTCDay() !== 6 && !closed.has(key(d));
      const nextOpen = (d) => { let x = plusDays(d, 1); for (let i = 0; i < 60 && !open(x); i++) x = plusDays(x, 1); return x; };
      const addOpen = (d, n) => { let x = d; for (let i = 0; i < n; i++) x = nextOpen(x); return x; };
      const cutoff = parseInt(el.dataset.cutoff, 10) || 0;
      const handling = parseInt(el.dataset.handling, 10) || 0;
      const tMin = Math.max(1, parseInt(el.dataset.min, 10) || 1);
      const tMax = Math.max(tMin, parseInt(el.dataset.max, 10) || tMin);
      const n = nowParts();
      const today = new Date(Date.UTC(n.y, n.m - 1, n.d));
      let ship; let shipsToday = false;
      if (open(today) && n.h < cutoff) { ship = today; shipsToday = true; } else { ship = nextOpen(today); }
      if (handling > 0) { ship = addOpen(ship, handling); shipsToday = false; }
      const from = addOpen(ship, tMin);
      const to = addOpen(ship, tMax);
      const range = key(from) === key(to) ? fmtShort.format(from) : `${fmtShort.format(from)} – ${fmtShort.format(to)}`;
      const s = V.strings || {};
      const main = (s.deliveryEstimate || '{range}').replace('{range}', range);
      const sub = shipsToday ? (s.deliveryToday || '').replace('{time}', String(cutoff)) : (s.deliveryOn || '').replace('{day}', fmtLong.format(ship));
      return { main, sub };
    }

    function render(el) {
      el.dataset.ready = 'true';
      try {
        const { main, sub } = compute(el);
        $('[data-delivery-main]', el).textContent = main;
        $('[data-delivery-sub]', el).textContent = sub;
        el.hidden = el.dataset.available === 'false';
      } catch (e) { el.hidden = true; }
    }

    const initAll = (root = document) => $$('[data-delivery-estimate]:not([data-ready])', root).forEach(render);
    const refreshAll = () => $$('[data-delivery-estimate]').forEach(render);

    document.addEventListener('variant:change', (e) => {
      const section = e.target.closest('[data-product-section]') || e.target;
      const el = $('[data-delivery-estimate]', section);
      if (!el) return;
      const v = e.detail && e.detail.variant;
      el.dataset.available = v && v.available && !v.backorder ? 'true' : 'false';
      render(el);
    });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshAll(); });
    // Brytpunkten ligger på hel timme – räkna om när timmen slår, så att "skickas i dag" aldrig blir kvar för länge
    const scheduleHourly = () => {
      const now = new Date();
      const ms = (60 - now.getMinutes()) * 60000 - now.getSeconds() * 1000 + 500;
      setTimeout(() => { refreshAll(); scheduleHourly(); }, ms);
    };
    if (document.querySelector('[data-delivery-estimate]')) scheduleHourly();

    // Varukorgen ritas om av theme.js – nya rader får sitt datum direkt
    const watch = (node) => { if (node) new MutationObserver(() => initAll(node)).observe(node, { childList: true, subtree: true }); };
    return { initAll, watch };
  })();

  /* ==========================================================================
     Produktsida: dela och tillbaka till listan
     ========================================================================== */
  function initShare(section) {
    const btn = $('[data-share]', section);
    const wrap = $('[data-share-wrap]', section);
    if (!btn || !wrap) return;
    const canShare = typeof navigator.share === 'function';
    const canCopy = !!(navigator.clipboard && navigator.clipboard.writeText);
    if (!canShare && !canCopy) return;
    wrap.hidden = false;
    btn.addEventListener('click', async () => {
      const url = btn.dataset.url || window.location.href.split('?')[0];
      if (canShare) {
        try { await navigator.share({ title: btn.dataset.title || document.title, url }); } catch (e) { /* avbrutet */ }
        return;
      }
      try { await navigator.clipboard.writeText(url); if (V.toast) V.toast(btn.dataset.copied || url); } catch (e) { /* ingen åtkomst */ }
    });
  }

  function initBackLink(section) {
    const link = $('[data-back-link]', section);
    if (!link || !document.referrer) return;
    let ref;
    try { ref = new URL(document.referrer); } catch (e) { return; }
    if (ref.origin !== window.location.origin) return;
    const fromSearch = ref.pathname.startsWith('/search');
    const fromList = /^\/collections\//.test(ref.pathname) && !/\/products\//.test(ref.pathname);
    if (!fromSearch && !fromList) return;
    if (fromSearch && link.dataset.textSearch) $('[data-back-text]', link).textContent = link.dataset.textSearch;
    link.href = ref.pathname + ref.search;
    link.hidden = false;
    // Hopp inom sidan (t.ex. till omdömena) lägger till steg i historiken – räkna dem
    let inPage = 0;
    window.addEventListener('hashchange', () => { inPage += 1; });
    link.addEventListener('click', (e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      if (window.history.length > 1) { e.preventDefault(); window.history.go(-(1 + inPage)); }
    });
  }

  /* ==========================================================================
     Senast visade
     ========================================================================== */
  const RECENT_KEY = 'vildblad:recent';
  function recordView() {
    const section = $('[data-product-section]');
    if (!section) return;
    const m = (section.dataset.productUrl || '').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    const handle = decodeURIComponent(m[1]);
    const list = store.list(RECENT_KEY).filter((h) => h !== handle);
    list.unshift(handle);
    store.set(RECENT_KEY, list.slice(0, 12));
  }

  async function renderRecent(el) {
    const list = $('[data-recently-list]', el);
    if (!list) return;
    const exclude = el.dataset.exclude;
    const limit = parseInt(el.dataset.limit, 10) || 4;
    const handles = store.list(RECENT_KEY).filter((h) => h !== exclude);
    if (!handles.length) { el.hidden = true; return; }
    // Samma produktkort som i resten av butiken (snippets/product-card via ?view=card)
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const results = await Promise.all(handles.slice(0, limit + 3).map(async (h) => {
      try {
        const res = await fetch(`${root}products/${encodeURIComponent(h)}?view=card`, { credentials: 'same-origin' });
        if (!res.ok) return null;
        const html = await res.text();
        return html.indexOf('data-product-card') === -1 ? null : html;
      } catch (e) { return null; }
    }));
    const items = results.filter(Boolean).slice(0, limit).map((html) => {
      const li = document.createElement('li');
      li.innerHTML = html;
      return li;
    });
    list.replaceChildren(...items);
    el.hidden = items.length === 0;
  }

  function bindRecentClear(el) {
    const btn = $('[data-recently-clear]', el);
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = 'true';
    btn.addEventListener('click', () => {
      store.remove(RECENT_KEY);
      el.hidden = true;
      document.getElementById('MainContent')?.focus({ preventScroll: true });
    });
  }

  function initRecent() {
    $$('[data-recently-viewed]').forEach((el) => {
      renderRecent(el);
      bindRecentClear(el);
    });
  }

  /* ==========================================================================
     Filter: visa hur många produkter valen ger innan lådan stängs
     ========================================================================== */
  function initFilterCount() {
    let controller = null;
    let seq = 0;
    const update = debounce(async (form) => {
      const btn = $('[data-filter-submit]', form);
      const root = form.closest('[data-collection]') || $('[data-collection]');
      if (!btn || !root) return;
      const params = new URLSearchParams();
      new FormData(form).forEach((value, k) => { if (value !== '') params.append(k, value); });
      params.set('section_id', root.dataset.sectionId);
      controller?.abort();
      controller = new AbortController();
      const mine = ++seq;
      try {
        const res = await fetch(`${form.getAttribute('action')}?${params.toString()}`, { signal: controller.signal });
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const countEl = $('[data-product-count]', doc);
        if (!countEl) return;
        const count = parseInt(countEl.dataset.count, 10);
        if (Number.isNaN(count) || mine !== seq) return;
        const label = count === 0 ? btn.dataset.labelNone : (count === 1 ? btn.dataset.labelOne : btn.dataset.labelOther);
        if (label) btn.textContent = label.replace('[count]', String(count));
      } catch (e) { /* behåll texten */ }
    }, 350);
    const onChange = (e) => {
      const form = e.target.closest && e.target.closest('[data-filter-form]');
      if (form) update(form);
    };
    document.addEventListener('change', onChange);
    document.addEventListener('input', (e) => { if (e.target.type === 'number') onChange(e); });
  }

  /* ==========================================================================
     Sök: senaste sökningar
     ========================================================================== */
  const SEARCH_KEY = 'vildblad:searches';
  const rememberSearch = (q) => {
    const term = (q || '').trim();
    if (term.length < 2) return;
    const list = store.list(SEARCH_KEY).filter((t) => t.toLowerCase() !== term.toLowerCase());
    list.unshift(term);
    store.set(SEARCH_KEY, list.slice(0, 6));
  };
  function renderSearches() {
    const box = $('[data-recent-searches]');
    if (!box) return;
    const list = $('[data-recent-searches-list]', box);
    const terms = store.list(SEARCH_KEY);
    list.innerHTML = '';
    terms.forEach((t) => {
      const a = document.createElement('a');
      a.className = 'chip';
      a.href = `${(V.routes && V.routes.search) || '/search'}?q=${encodeURIComponent(t)}&options%5Bprefix%5D=last`;
      a.textContent = t;
      list.appendChild(a);
    });
    box.hidden = terms.length === 0;
  }
  function initSearches() {
    const drawer = $('[data-search-drawer]');
    if (drawer) {
      const input = $('[data-search-input]', drawer);
      $('form', drawer)?.addEventListener('submit', () => rememberSearch(input.value));
      drawer.addEventListener('click', (e) => { if (e.target.closest('[data-search-results] a')) rememberSearch(input.value); });
      drawer.addEventListener('drawer:open', renderSearches);
      $('[data-recent-searches-clear]', drawer)?.addEventListener('click', () => { store.remove(SEARCH_KEY); renderSearches(); input?.focus(); });
    }
    const pageInput = $('#SearchPageInput');
    if (pageInput && pageInput.value) rememberSearch(pageInput.value);
    renderSearches();
  }

  /* ==========================================================================
     Guider: innehållsförteckning när texten har minst tre mellanrubriker
     ========================================================================== */
  function initToc() {
    const toc = $('[data-article-toc]');
    const content = $('[data-article-content]');
    if (!toc || !content) return;
    const heads = $$('h2', content).filter((h) => h.textContent.trim());
    if (heads.length < 3) return;
    const list = $('[data-article-toc-list]', toc);
    const used = new Set();
    heads.forEach((h, i) => {
      if (!h.id) {
        let slug = h.textContent.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || `avsnitt-${i + 1}`;
        while (used.has(slug) || document.getElementById(slug)) slug += '-2';
        h.id = slug;
      }
      used.add(h.id);
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
  }

  /* ==========================================================================
     Till toppen
     ========================================================================== */
  function initToTop() {
    const btn = $('[data-to-top]');
    if (!btn) return;
    let shown = false;
    let raf = 0;
    const check = () => {
      raf = 0;
      const show = window.scrollY > window.innerHeight * 2;
      if (show !== shown) { shown = show; btn.hidden = !show; }
    };
    window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
    check();
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior });
      const main = document.getElementById('MainContent');
      setTimeout(() => main && main.focus({ preventScroll: true }), reduceMotion ? 0 : 500);
    });
  }

  /* ==========================================================================
     Bakåtknappen: sidor som visas från webbläsarens cache får rätt varukorg
     ========================================================================== */
  window.addEventListener('pageshow', async (e) => {
    if (!e.persisted) return;
    const Cart = (window.Vildblad || {}).Cart;
    if (!Cart) return;
    try {
      Cart.refreshCount();
      const ids = [];
      if ($('[data-cart-drawer]')) ids.push('cart-drawer');
      const pageId = $('[data-cart-page]')?.dataset.sectionId;
      if (pageId) ids.push(pageId);
      if (ids.length) {
        const res = await fetch(`${(V.routes && V.routes.root) || '/'}?sections=${ids.join(',')}`);
        if (res.ok) Cart.render(await res.json());
      }
    } catch (err) { /* tyst */ }
  });

  /* ==========================================================================
     Ångra köp: steg 1 (uppgifter) → steg 2 (sammanfattning och uttrycklig bekräftelse)
     Steg 1-knappen skickar aldrig något. Utan JavaScript syns steg 2 direkt, så att
     bekräftelseknappen alltid är det som skickar.
     ========================================================================== */
  function initWithdrawal() {
    const forms = $$('[data-withdraw-form]');
    if (!forms.length) return;
    const params = new URLSearchParams(window.location.search);
    let saved = null;

    const syncScope = (form) => {
      const some = !!$('[data-scope-some]', form)?.checked;
      const wrap = $('[data-scope-items]', form);
      const field = $('[data-scope-items-field]', form);
      if (wrap) wrap.hidden = !some;
      if (field) { field.disabled = !some; field.required = some; }
    };
    const showStep = (form, n) => {
      const s1 = $('[data-withdraw-step="1"]', form);
      const s2 = $('[data-withdraw-step="2"]', form);
      if (!s1 || !s2) return;
      s1.hidden = n !== 1;
      s2.classList.toggle('is-active', n === 2);
    };
    const prep = (form) => {
      const order = params.get('order');
      const orderInput = $('input[name="contact[Ordernummer]"]', form);
      if (order && orderInput && !orderInput.value) orderInput.value = order;
      syncScope(form);
      showStep(form, 1);
    };
    const buildSummary = (form) => {
      const summary = $('[data-withdraw-summary]', form);
      if (!summary) return;
      summary.innerHTML = '';
      const seen = new Set();
      $$('[data-summary], [data-scope-some]', $('[data-withdraw-step="1"]', form)).forEach((field) => {
        if (field.disabled || seen.has(field.name)) return;
        seen.add(field.name);
        let value;
        let label = field.dataset.summary;
        if (field.type === 'radio') {
          const checked = $(`input[name="${CSS.escape(field.name)}"]:checked`, form);
          value = checked && checked.value;
          label = label || $(`input[name="${CSS.escape(field.name)}"][data-summary]`, form)?.dataset.summary;
        } else {
          value = field.value.trim();
        }
        if (!value || !label) return;
        const dt = document.createElement('dt'); dt.textContent = label;
        const dd = document.createElement('dd'); dd.textContent = value;
        summary.append(dt, dd);
      });
    };
    const goToConfirm = (form) => {
      syncScope(form);
      if (!form.reportValidity()) return;
      buildSummary(form);
      showStep(form, 2);
      $('[data-withdraw-confirm-title]', form)?.focus();
    };

    forms.forEach(prep);

    document.addEventListener('change', (e) => {
      const form = e.target.closest && e.target.closest('[data-withdraw-form]');
      if (form && e.target.name === 'contact[Gäller]') syncScope(form);
    });
    document.addEventListener('click', (e) => {
      const next = e.target.closest('[data-withdraw-next]');
      if (next) { goToConfirm(next.closest('[data-withdraw-form]')); return; }
      const back = e.target.closest('[data-withdraw-back]');
      if (back) {
        const form = back.closest('[data-withdraw-form]');
        showStep(form, 1);
        $('input:not([type="hidden"])', form)?.focus();
        return;
      }
      if (e.target.closest('[data-print]')) window.print();
    });

    // Enter i ett fält i steg 1 går till steg 2 i stället för att skicka (fångas före vb2.js)
    document.addEventListener('submit', (e) => {
      const form = e.target.closest && e.target.closest('[data-withdraw-form]');
      if (!form) return;
      const s2 = $('[data-withdraw-step="2"]', form);
      if (!s2) return;
      if (!s2.classList.contains('is-active')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        goToConfirm(form);
        return;
      }
      saved = { entries: Array.from(new FormData(form).entries()), summary: $('[data-withdraw-summary]', form)?.innerHTML || '' };
    }, true);

    // När vb2.js har bytt ut formuläret: kvitto med tid och sammanfattning, eller tillbaka med ifyllda uppgifter vid fel
    $$('.withdraw__card').forEach((card) => {
      new MutationObserver(() => {
        const form = $('[data-withdraw-form]', card);
        if (!form || form.dataset.handled) return;
        form.dataset.handled = 'true';
        const done = $('[data-withdraw-done]', form);
        if (done) {
          const t = $('[data-withdraw-time]', done);
          if (t) t.textContent = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Stockholm', dateStyle: 'short', timeStyle: 'short' }).format(new Date());
          const dl = $('[data-withdraw-receipt-summary]', done);
          if (dl && saved && saved.summary) { dl.innerHTML = saved.summary; dl.hidden = false; }
          return;
        }
        prep(form);
        if (saved) {
          saved.entries.forEach(([k, v]) => {
            $$(`[name="${CSS.escape(k)}"]`, form).forEach((el) => {
              if (el.type === 'radio' || el.type === 'checkbox') el.checked = el.value === v;
              else if (el.type !== 'hidden') el.value = v;
            });
          });
          syncScope(form);
        }
      }).observe(card, { childList: true });
    });
  }

  /* ==========================================================================
     Start
     ========================================================================== */
  function init() {
    const safe = (fn) => { try { fn(); } catch (e) { /* en del som fallerar ska inte stoppa resten */ } };
    safe(initWithdrawal);
    $$('[data-product-section]').forEach((section) => {
      safe(() => initThumbs(section));
      safe(() => initZoom(section));
      safe(() => initShare(section));
      safe(() => initBackLink(section));
    });
    safe(() => Delivery.initAll());
    safe(() => { Delivery.watch($('#CartDrawer')); Delivery.watch($('[data-cart-page]')); });
    safe(recordView);
    safe(initRecent);
    safe(initFilterCount);
    safe(initSearches);
    safe(initToc);
    safe(initToTop);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-product-section]', e.target).forEach((section) => { initThumbs(section); initZoom(section); initShare(section); });
    Delivery.initAll(e.target);
    $$('[data-recently-viewed]', e.target).forEach((el) => { renderRecent(el); bindRecentClear(el); });
  });
})()
